export function shost() {
  let host = window.location.host
  if (/appbdsm.com/g.test(host)) {
    return 1
  } else if (/appyoufan.com/g.test(host)) {
    return 2
  } else if (/taowoapp.com/g.test(host)) {
    return 3
  } else {
    return 0
  }
}

export function webTitle() {
  let s = shost()
  if (s == 1) {
    return '嗨翻APP'
  } else if (s == 2) {
    // return "右翻"
    // return '斯目'
    return "探对"
  } else if (s == 3) {
    return "嗨翻"
  } else {
    return '澍元'
  }
}
export function company() {
  let s = shost()
  if (s == 1) {
    return '武汉澍元网络科技有限公司'
  } else if (s == 2) {
    return '武汉斯目网络科技有限公司'
  } else if (s == 3) {
    return '深圳曼八网络科技有限公司'
  }
  return '武汉澍元网络科技有限公司'
}
export function phone() {
  let s = shost()
  if (s == 1) {
    return '18086680561'
  } else if (s == 2) {
    return '13667223247'
  }
  return '18001093975'
}

export function mail() {
  let s = shost()
  if (s == 1) {
    return '1971913398@qq.com'
  } else if (s == 2) {
    return '329291362@qq.com'
  }
  return 'ashu@wefaceapp.com'
}

export function icp() {
  let s = shost()
  if (s == 1) {
    return '鄂ICP备20013007号-2'
  } else if (s == 2) {
    return '鄂ICP备20011305号-2'
  } else if (s==3){
    return '粤ICP备2021153642号-2'
  } else {
    return '鄂ICP备18011355号-2'
  }
}
export function location() {
  let s = shost()
  if (s == 1) {
    return '武昌区武珞路628号A座24层11、12号鹏协创业孵化器A15-2'
  } else if (s == 2) {
    return '湖北省武汉市东西湖区将军路街道办事处银潭路02号汽车维修及电子产品生产项目4号厂房2层M224-2'
  } else if (s==3){
    return '深圳市福田区沙头街道天安社区泰然八路18号安华小区6栋厂房七层746E'
  } else {
    return '湖北省武汉市武昌区小洪山东区34号'
  }
}

export function logo() {
  let s = shost()
  if (s == 1) {
    return require('@/assets/logo_haifn@2x.png')
  } else if (s == 2) {
    return require('@/assets/4c2c76b1ec9ea74434ebf428fdae366.png')
    // return require('@/assets/logo_simu@2x.png')
  } else if (s == 3) {
    return require('@/assets/logo_haifn@2x.png')
  }
  return require('@/assets/logo.png')
}

export function downColor() {
  let s = shost()
  if (s == 1) {
    return '#F04371'
  } else if (s == 2) {
    return '#fc9014'
  } else if (s == 3) {
    return '#F04371'
  }
  return '#2395FE'
}

export function bg() {
  let s = shost()
  let left = ''
  let right = ''
  if (s == 1) {
    left = require('@/assets/bg1@2x (1).png')
    right = require('@/assets/bg2@2x (1).png')
  } else if (s == 2) {
    left = require('@/assets/bg1@2x.png')
    right = require('@/assets/bg2@2x.png')
  } else if (s == 3) {
    left = require('@/assets/bg1@2x (1).png')
    right = require('@/assets/bg2@2x (1).png')
  } else {
    left = require('@/assets/bg_left.png')
    right = require('@/assets/bg_right.png')
  }
  return `url("${left}"),url("${right}")`
}

export function mobile() {
  let s = shost()
  if (s == 1) {
    return require('@/assets/pic_haifan@2x.png')
  } else if (s == 2) {
    return require('@/assets/pic_simu1@2x.png')
    return require('@/assets/pic_simu@2x (1).png')
  } else if (s == 3) {
    return require('@/assets/pic_haifan_2.png')
  } else {
    return require('@/assets/iphone.png')
  }
}

export function downurl() {
  let s = shost()
  if (s == 1) {
    return 'https://simu.taowoapp.com/release/chirp_1.2.7_127_1_shuyuan_sign.apk'
  } else if (s == 2) {
    return 'http://simu-image.taowoapp.com/apk/app-tandui-release.apk'
    return 'http://simu-image.taowoapp.com/apk/app-youfan-icp.apk'
  } else if (s == 3) {
    return 'http://fir.wtlyhqb.com/ngwc'
  } else {
    return 'https://sj.qq.com/myapp/detail.htm?apkName=com.wuhui.taowo'
  }
}
